module.exports = (__webpack_require__(0))(35);


//////////////////
// WEBPACK FOOTER
// delegated ./clients/web/src/models/FileModel.js from dll-reference girder_lib
// module id = 129
// module chunks = 0